import React, { useEffect } from 'react';
import { Button } from '@vtbhome/juicyfront';
import { FeedbackRequestDownloadProps } from './types';
import { Toast } from '@shared/ui/toast/toast';
import toast from 'react-hot-toast';
import { getQueryError } from '@shared/lib/utils/get-query-error/get-query-error';
import { AllDownload } from '@vtbhome/juicyfront/indexIcon';
import { useFeedbackRequestDownloadSharedQuery } from '@entities/feedback-request/libs/hooks/use-feedback-request-download-shared-query/use-feedback-request-download-shared-query';
import { forceDownload } from '@shared/lib/utils/force-download/force-download';
import { normalizeDatepickerValue } from '@shared/lib/utils/normalize-datepicker-value/normalize-datepicker-value';

export const FeedbackRequestDownload: React.FC<FeedbackRequestDownloadProps> = ({ feedbackRequestsListParameters }) => {
    const [feedbackrequestDownload, feedbackRequestDownloadResult] =
        useFeedbackRequestDownloadSharedQuery(feedbackRequestsListParameters);

    useEffect(() => {
        if (feedbackRequestDownloadResult.isSuccess) {
            toast.custom((t) => {
                return (
                    <Toast
                        type='success'
                        title='Успешно!'
                        description='Обращения успешно выгружены'
                        onClose={() => {
                            toast.remove(t.id);
                        }}
                    />
                );
            });
        } else if (feedbackRequestDownloadResult.isError) {
            toast.custom((t) => {
                return (
                    <Toast
                        type='error'
                        title='Ошибка!'
                        description={`Обращения не удалось выгрузить.\n${getQueryError(feedbackRequestDownloadResult)?.message}`}
                        onClose={() => {
                            toast.remove(t.id);
                        }}
                    />
                );
            });
        }
    }, [feedbackRequestDownloadResult.isSuccess, feedbackRequestDownloadResult.isError]);

    return (
        <Button
            buttonType='secondary'
            size='s'
            startAdornment={<AllDownload size='xxs' />}
            onClick={() =>
                feedbackrequestDownload(feedbackRequestsListParameters).then((file) => {
                    return (
                        file.data &&
                        forceDownload(
                            `Request_report${normalizeDatepickerValue(feedbackRequestsListParameters.dateFrom, feedbackRequestsListParameters.dateTo, '-')}`,
                            file.data
                        )
                    );
                })
            }
        />
    );
};
